import { action } from 'typesafe-actions';

import ActionTypes from '../constants/furniture';
import { CabinetJson } from 'lib/modelBuilder/Data';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import {
  CabinetSupport,
  Material,
  ShelfComposition,
} from 'lib/modelBuilder/constants';
import { PositionPiece } from 'lib/modelBuilder/type';
import { Message } from 'containers/InteractiveArea/Message';
import { HistoryStep } from 'containers/Configurator/types';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';

export const addCabinetAction = (cabinet: Cabinet) =>
  action(ActionTypes.FURNITURE_ADD_CABINET, { cabinet });

export const selectCabinetAction = (id: string) =>
  action(ActionTypes.FURNITURE_SELECT_CABINET, { id });

export const selectCabinetFromIdAction = (id: string) =>
  action(ActionTypes.FURNITURE_SELECT_FROMID_CABINET, { id });

export const removeCabinetAction = (id: string) =>
  action(ActionTypes.FURNITURE_REMOVE_CABINET, { id });

export const restoreFurnitureStepAction = (step: HistoryStep) =>
  action(ActionTypes.FURNITURE_RESTORE_STEP, { step });

export const reorderingFurnitureAction = (
  source: number,
  destination: number,
) =>
  action(ActionTypes.FURNITURE_REORDERING, {
    source,
    destination,
  });

export const renameFurnitureAction = (name: string) =>
  action(ActionTypes.FURNITURE_RENAME, { name });

export const selectFurnitureAction = () => action(ActionTypes.SELECT_FURNITURE);

export const loadFurnitureAction = (reference?: string, old = false) =>
  action(ActionTypes.FURNITURE_LOAD_REQUEST, { reference, old });

export const loadFurnitureSuccessAction = (furniture: Furniture) =>
  action(ActionTypes.FURNITURE_LOAD_SUCCESS, { furniture });

export const loadFurnitureFailureAction = (error: any) =>
  action(ActionTypes.FURNITURE_LOAD_FAILURE, { error });

export const loadCabinetAction = (id: number) =>
  action(ActionTypes.CABINET_LOAD_REQUEST, { id });

export const loadCabinetSuccessAction = (data: CabinetJson, cabinet: Cabinet) =>
  action(ActionTypes.CABINET_LOAD_SUCCESS, { data, cabinet });

export const loadCabinetFailureAction = (error: any) =>
  action(ActionTypes.CABINET_LOAD_FAILURE, { error });

export const addShelf = (level?: number) =>
  action(ActionTypes.CABINET_ADD_SHELF, { level: level });
export const addShelfFailure = (error: any) =>
  action(ActionTypes.CABINET_ADD_SHELF, { error });

export const removeShelfRequest = (level?: number) =>
  action(ActionTypes.CABINET_REMOVE_SHELF_REQUEST, { level: level });
export const removeShelfFailure = (error: any) =>
  action(ActionTypes.CABINET_WIDTH_FAILURE, { error });

export const updateCabinetSuccess = (
  furniture: Furniture,
  selectedId: string | null,
  preview = false,
  message?: Message,
  history = true,
) =>
  action(ActionTypes.CABINET_UPDATE_SUCCESS, {
    furniture,
    selectedId,
    preview,
    message,
    history,
  });

export const restoreCabinet = (cabinet: Cabinet) =>
  action(ActionTypes.CABINET_RESTORE, { cabinet });

// Width
export const setWidthRequest = (value: number, preview = false) =>
  action(ActionTypes.CABINET_WIDTH_REQUEST, { value, preview });
export const setWidthFailure = (error: any) =>
  action(ActionTypes.CABINET_WIDTH_FAILURE, { error });

// Depth
export const setDepthRequest = (value: number, preview = false) =>
  action(ActionTypes.CABINET_DEPTH_REQUEST, { value, preview });
export const setDepthFailure = (error: any) =>
  action(ActionTypes.CABINET_DEPTH_FAILURE, { error });

// Corner
export const setCornersRequest = (reference: string, preview = false) =>
  action(ActionTypes.CABINET_CORNER_REQUEST, { reference, preview });
export const setCornersFailure = (error: any) =>
  action(ActionTypes.CABINET_CORNER_FAILURE, { error });

// Support
export const setSupportRequestAction = (
  support: CabinetSupport,
  preview = false,
  height = 0,
  material: Material = Material.Wood,
) =>
  action(ActionTypes.CABINET_SUPPORT_REQUEST, {
    support,
    height,
    material,
    preview,
  });
export const setSupportFailure = (error: any) =>
  action(ActionTypes.CABINET_SUPPORT_FAILURE, { error });

// Shelfs height
export const setShelfHeight = (
  height: number,
  selectedLevelShelf: number[],
  preview = false,
) =>
  action(ActionTypes.CABINET_SHELFS_HEIGHT_REQUEST, {
    height,
    selectedLevelShelf,
    preview,
  });
export const setShelfHeightFailure = (error: any) =>
  action(ActionTypes.CABINET_SHELFS_HEIGHT_FAILURE, { error });

// Shelf switch position
export const switchShelfPosition = (level: number, positionChange: number) =>
  action(ActionTypes.CABINET_SWITCH_SHELF_REQUEST, {
    level,
    positionChange,
  });
export const switchShelfPositionFailure = (error: any) =>
  action(ActionTypes.CABINET_SWITCH_SHELF_FAILURE, { error });

// Shelf Composition
export const setComposition = (
  composition: ShelfComposition,
  preview = false,
) =>
  action(ActionTypes.CABINET_SHELF_SET_COMPOSITION, { composition, preview });
export const setDoorsFailure = (error: any) =>
  action(ActionTypes.CABINET_SHELF_SET_COMPOSITION_FAILURE, { error });

export const addPieceAction = (type: string, position: PositionPiece) =>
  action(ActionTypes.CABINET_SHELF_ADD_PIECE, { type, position });
export const addPieceFailureAction = (error: any) =>
  action(ActionTypes.CABINET_SHELF_ADD_PIECE_FAILURE, { error });

// Drawers
export const setDrawersRequest = (combos: number[], preview = false) =>
  action(ActionTypes.CABINET_DRAWERS_COMBINATION, {
    combos,
    preview,
  });
export const setDrawersFailure = (error: any) =>
  action(ActionTypes.CABINET_DRAWERS_COMBINATION_FAILURE, { error });

export const navigateShelvesAction = (direction: number) =>
  action(ActionTypes.NAVIGATE_SHELVES, { direction });

export const displayFurniture = () =>
  action(ActionTypes.DISPLAY_FURNITURE_REQUEST);

export const setImageAction = (image: string, cabinetId?: string) =>
  action(ActionTypes.FURNITURE_SET_IMAGE, {
    image,
    cabinetId,
  });
